import { BahasaResponse } from "../../../../models/Bahasa";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function viewFile(data: { id: string }) {
  try {
    const res = await ApiClient.get(`/ViewFile?id=${data.id}`, {
      responseType: "arraybuffer",
    });
    return res.data;
  } catch (error: any) {
    return null;
  }
}

export const useFetchViewFile = mutationWrapper(viewFile);
